import { useSelector } from 'react-redux'

import useResolvePrivacyPolicy from './useResolvePrivacyPolicy'

const showBrandingSelector = state => state.embed.configuration.showBranding || false

const useHasFooter = (): boolean => {
  const showBranding = useSelector(showBrandingSelector)
  const { noPolicy } = useResolvePrivacyPolicy()
  return showBranding || !noPolicy
}

export default useHasFooter
